const supportedImageTypes = ['image/bmp', 'image/gif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/webp'];

export const isSupportedImage = attachment => {
  return supportedImageTypes.includes(attachment.contentType);
};
